import { custom, deserialize, optional, serializable } from 'serializr';
import { Base } from './base.model';
import { Deserializable } from './deserializable';
import { OnBoarding } from './onboarding.enum';

export class HelpPreference extends Base implements Deserializable {
  @serializable
  public userId: number;
  @serializable(
    optional(
      custom(
        (v) => JSON.stringify(v),
        (v) => JSON.parse(v),
      ),
    ),
  )
  public helpMessages: JSON;
  @serializable(
    custom(
      (v) => v,
      (v) => v,
    ),
  )
  public preferences: string[];

  deserialize(input: any): this {
    return Object.assign(this, deserialize(HelpPreference, input));
  }

  get hasOnBoarding() {
    return (
      this.preferences.includes(OnBoarding.ON_BOARDING_INFO) ||
      this.preferences.includes(OnBoarding.ON_BOARDING_EXPLORE)
    );
  }

  get hasOnBoardingInfo() {
    return this.preferences.includes(OnBoarding.ON_BOARDING_INFO);
  }

  get hasOnBoardingExplore() {
    return this.preferences.includes(OnBoarding.ON_BOARDING_EXPLORE);
  }
}
